import React from 'react';
import ImportExportExcelModal from '../../components/simulation/Outils/ImportExportExcel/ImportExportExcelModal';
import type Simulation from '../../interfaces/simulation/simulation';
import BaseOutil from './BaseOutil';

class ImportExportExcel extends BaseOutil {
	constructor() {
		super();
		this.code = 'IMP_EXC';
		this.icon = {
			iconSet: 'Lucide',
			name: 'ArrowDownUp',
		};
	}

	title = 'Exporter / Importer un classeur bureautique';

	renderModal(
		simulation: Simulation,
		onClose: () => void,
		onValidate: (data: unknown) => void,
		open: boolean,
	) {
		return (
			<ImportExportExcelModal
				onClose={onClose}
				onValidate={onValidate}
				open={open}
				simulation={simulation}
			/>
		);
	}
}

export default ImportExportExcel;
